import { IntlShape } from 'react-intl';
import { CatalogReleaseEvent } from '../../../../redux/api/fymAPI.types';
import { releaseMessages } from './releaseMessages';

/**
 * The body of the green "is out" card (design g3): "We found it on 6 services and linked it to
 * your catalog row. The master, 2 reels and the pre-save moved with it." An answer with no
 * `moved` (an older API) keeps the general sentence. `formatList` joins the list in the
 * viewer's locale, so English gets the serial comma ("2 reels, and the pre-save").
 */
export function linkedCardBody(intl: IntlShape, event: CatalogReleaseEvent): string {
  const { moved } = event;
  if (moved === undefined || moved === null) {
    return intl.formatMessage(releaseMessages.linkedBody);
  }
  const found = intl.formatMessage(releaseMessages.linkedFound, { count: moved.serviceCount });
  const items: string[] = [];
  if (moved.hasMaster) {
    items.push(intl.formatMessage(releaseMessages.movedMaster));
  }
  if (moved.reelCount > 0) {
    items.push(intl.formatMessage(releaseMessages.movedReels, { count: moved.reelCount }));
  }
  if (moved.hasPresave) {
    items.push(intl.formatMessage(releaseMessages.movedPresave));
  }
  if (items.length === 0) {
    return found;
  }
  const list = intl.formatList(items, { type: 'conjunction' });
  const sentence = intl.formatMessage(releaseMessages.movedWith, { items: list });
  return `${found} ${sentence.charAt(0).toLocaleUpperCase(intl.locale)}${sentence.slice(1)}`;
}
